import { useState, useEffect } from 'react';
import { mainReviews } from '../../../mocks/reviews';

const HeroSection = () => {
  const [currentReview, setCurrentReview] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % mainReviews.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const handleConsultClick = () => {
    window.open('http://pf.kakao.com/_KkAxon/chat', '_blank', 'noopener,noreferrer');
  };

  const review = mainReviews[currentReview];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-pink-100 via-purple-50 to-blue-50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-block bg-neon-pink/20 border border-neon-pink text-neon-pink px-4 py-1.5 rounded-full text-xs font-medium mb-6 animate-pulse">
              특별 한정 이벤트 진행중
            </div>

            <h1 className="text-5xl md:text-7xl font-black text-navy leading-tight mb-6">
              유흥업계 전문<br />
              광고·홍보 디자인
            </h1>

            <p className="text-lg text-gray-900 mb-8">
              구인광고부터 업체 홍보까지, 1~3일 완성
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <button
                onClick={handleConsultClick}
                className="bg-neon-pink text-white px-8 py-4 rounded-full font-bold hover:bg-neon-pink/90 hover:scale-105 transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                상담 신청하기
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="bg-white text-navy px-8 py-4 rounded-full font-bold hover:bg-gray-100 hover:scale-105 transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                작업 사례 보기
                <i className="ri-arrow-down-line"></i>
              </button>
            </div>
          </div>

          {/* Right Content - Review Slider */}
          <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 hover:shadow-3xl transition-shadow duration-300">
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-neon-pink text-xl animate-pulse" style={{ animationDelay: `${i * 100}ms` }}></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-navy mb-4">
                {review.title}
              </h3>

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mb-6">
                {review.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-neon-light text-neon-pink px-3 py-1 rounded text-xs font-medium hover:scale-110 transition-transform cursor-pointer"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-600 leading-relaxed mb-8 text-sm">
                {review.content}
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-neon-light flex items-center justify-center">
                  <span className="text-neon-pink font-bold text-lg">
                    {review.initial}
                  </span>
                </div>
                <div>
                  <p className="font-bold text-navy text-sm">{review.author}</p>
                  <p className="text-gray-500 text-xs">{review.company}</p>
                </div>
              </div>

              {/* Slider Dots */}
              <div className="flex justify-center gap-2 mt-8">
                {mainReviews.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentReview(index)}
                    className={`h-2 rounded-full transition-all cursor-pointer ${
                      index === currentReview
                        ? 'bg-neon-pink w-8'
                        : 'bg-gray-300 w-2 hover:bg-gray-400'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
